export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime (time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 将剩余秒数格式化为xx小时xx分钟
export function formatSeconds (time) {
  let hours = parseInt(time / (60 * 60));
  let minutes = Math.ceil((time - (60 * 60) * hours) / 60);
  let data = '';
  if (hours) {
    data += hours + " 小时 ";
  }
  data += minutes + " 分钟 ";
  return data;
}

export function bytesToSize2 (bytes) {
  bytes = parseInt(bytes);
  if (bytes === 0) return '0 B';
  let k = 1024,
    sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
}

export function bytesToSize (file) {
  if (file.bytes) {
    let bytes = parseInt(file.bytes);
    if (bytes === 0) return '0 B';
    let k = 1024,
      sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i];
  } else {
    return '-';
  }
}

// 获取长度为length的随机字符
export function random (length) {
  var str = Math.random().toString(36).substr(2);
  if (str.length >= length) {
    return str.substr(0, length);
  }
  str += random(length - str.length);
  return str;
}

// list生成tree(将detail禁用,detail的父级也禁用)
export function listToTree (list, detail = []) {
  const copyList = list.slice(0);
  const tree = [];
  for (let i = 0; i < copyList.length; i++) {
    // 找出每一项的父节点，并将其作为父节点的nodes
    for (let j = i; j < copyList.length; j++) {
      if (copyList[i].parent_number === copyList[j].number) {
        if (copyList[j].nodes === undefined) {
          copyList[j].nodes = [];
        }
        let isSelf = detail.find(item => item.number === copyList[i].number) ? true : false
        let isFather = detail.find(item => item.parent_number === copyList[i].number) ? true : false
        copyList[i].state = {
          disabled: isSelf
        };
        copyList[i].selectable = !isFather;
        copyList[i].text = copyList[i].name;
        copyList[j].nodes.push(copyList[i]);
      } else if (copyList[j].parent_number === copyList[i].number) {
        if (copyList[i].nodes === undefined) {
          copyList[i].nodes = [];
        }
        let isSelf = detail.find(item => item.number === copyList[j].number) ? true : false
        let isFather = detail.find(item => item.parent_number === copyList[j].number) ? true : false
        copyList[j].state = {
          disabled: isSelf
        };
        copyList[j].selectable = !isFather;
        copyList[j].text = copyList[j].name;
        copyList[i].nodes.push(copyList[j]);
      }
    }
    // 把根节点提取出来，parent_number为null的就是根节点
    if (copyList[i].parent_number === "0") {
      let isSelf = detail.find(item => item.number === copyList[i].number) ? true : false
      let isFather = detail.find(item => item.parent_number === copyList[i].number) ? true : false
      copyList[i].state = {
        disabled: isSelf
      };
      copyList[i].selectable = !isFather;
      copyList[i].text = copyList[i].name;
      tree.push(copyList[i]);
    }
  }
  return tree;
}

// list生成tree(仅将detail禁用)
export function listToTreeForCopy (list, detail = []) {
  const copyList = list.slice(0);
  const tree = [];
  for (let i = 0; i < copyList.length; i++) {
    // 找出每一项的父节点，并将其作为父节点的nodes
    for (let j = i; j < copyList.length; j++) {
      if (copyList[i].parent_number === copyList[j].number) {
        if (copyList[j].nodes === undefined) {
          copyList[j].nodes = [];
        }
        let isSelf = detail.find(item => item.number === copyList[i].number) ? true : false
        copyList[i].state = {
          disabled: isSelf
        };
        copyList[i].text = copyList[i].name;
        copyList[j].nodes.push(copyList[i]);
      } else if (copyList[j].parent_number === copyList[i].number) {
        if (copyList[i].nodes === undefined) {
          copyList[i].nodes = [];
        }
        let isSelf = detail.find(item => item.number === copyList[j].number) ? true : false
        copyList[j].state = {
          disabled: isSelf
        };
        copyList[j].text = copyList[j].name;
        copyList[i].nodes.push(copyList[j]);
      }
    }
    // 把根节点提取出来，parent_number为null的就是根节点
    if (copyList[i].parent_number === "0") {
      let isSelf = detail.find(item => item.number === copyList[i].number) ? true : false
      copyList[i].state = {
        disabled: isSelf
      };
      copyList[i].text = copyList[i].name;
      tree.push(copyList[i]);
    }
  }
  return tree;
}

// list生成tree(将expanded展开,expanded的所有父级也展开)
export function listToTree2 (list, expanded = [], selected) {
  const copyList = list.slice(0);
  const tree = [];
  for (let i = 0; i < copyList.length; i++) {
    // 找出每一项的父节点，并将其作为父节点的nodes
    for (let j = i; j < copyList.length; j++) {
      if (copyList[i].parent_number === copyList[j].number) {
        if (copyList[j].nodes === undefined) {
          copyList[j].nodes = [];
        }
        copyList[i].state = {
          expanded: expanded.indexOf(copyList[i].number) > -1 ? true : false,
          selected: selected === copyList[i].number ? true : false
        };
        copyList[i].text = copyList[i].name;
        copyList[j].nodes.push(copyList[i]);
      } else if (copyList[j].parent_number === copyList[i].number) {
        if (copyList[i].nodes === undefined) {
          copyList[i].nodes = [];
        }
        copyList[j].state = {
          expanded: expanded.indexOf(copyList[j].number) > -1 ? true : false,
          selected: selected === copyList[j].number ? true : false
        };
        copyList[j].text = copyList[j].name;
        copyList[i].nodes.push(copyList[j]);
      }
    }
    // 把根节点提取出来，parent_number为null的就是根节点
    if (copyList[i].parent_number === "0") {
      copyList[i].state = {
        expanded: expanded.indexOf(copyList[i].number) > -1 ? true : false,
        selected: selected === copyList[i].number ? true : false
      };
      copyList[i].text = copyList[i].name;
      tree.push(copyList[i]);
    }
  }
  return tree;
}

// 显示视频转换状态
export function transcodeStatusFilter (data) {
  if (data.file_type !== "video") {
    return false
  }
  let classStatus;
  switch (data.transcode_status) {
    case "wait":
      data.transcode_title = "视频未转码，点击转码";
      classStatus = "glyphicon glyphicon-info-sign";
      break;
    case "progess":
      data.transcode_title = "视频正在转码，点击查看转码状态";
      classStatus = "glyphicon glyphicon-time";
      break;
    case "success":
      data.transcode_title = "视频转码成功，可以播放";
      classStatus = "glyphicon glyphicon-ok-sign";
      break;
    case "fail":
      data.transcode_title = "视频转码失败，点击重试";
      classStatus = "glyphicon glyphicon-remove-sign";
      break;
    case "none":
      break;
    case "notran":
      data.transcode_title = "该文件暂不支持在线预览";
      // data.transcode_title = "本视频不支持转码，也不支持直接预览";
      classStatus = "glyphicon glyphicon-remove-sign";
      break;
  }
  return classStatus;
}

// 显示文件名称
export function formatData (data) {
  if (data.type === "file") {
    return data.file_ext ? data.name + "." + data.file_ext : data.name;
  } else if (data.type === "folder") {
    return data.name;
  }
}
// 显示文件位置
export function positionFilter (file) {
  let disk = file.group_number ? '群盘' : '云盘';
  let path = file.parent_number === "0" ? "/" : file.parent_path_name + '/';
  let ext = file.file_ext ? "." + file.file_ext : "";
  return disk + path + file.name + ext;
}

// 获取初始化日期
export function getFormatDate (date = null) {
  let ts = date
    ? new Date(date)
    : new Date(new Date().getTime());
  let y = ts.getFullYear();
  let M = ts.getMonth() + 1;
  if (M < 10) {
    M = "0" + M;
  }
  let d = ts.getDate();
  if (d < 10) {
    d = "0" + d;
  }
  let day = y + "-" + M + "-" + d;
  return day;
}

// 根据文件类型判断是否显示缩略图
export function isThumb (file_ext) {
  if (file_ext) {
    return ["jpg", "jpeg", "gif", "png", "webp"].indexOf(file_ext.toLowerCase()) > -1;
  } else {
    return false;
  }
}

// 获取URL的固定参数的值
export function getQueryVariable (url, variable) {
  const query = url.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) { return pair[1]; }
  }
  return (false);
}